<template>
    <v-btn v-if="isMobile" :disabled="!canUseCalendar" :color="color" icon @click="onClickCalendar()">
        <v-icon>$calendar</v-icon>
    </v-btn>
</template>

<script>

import {mapState, mapMutations} from 'vuex'

export default {
    methods: {
        ...mapMutations(['setShowCalendar']),
        onClickCalendar() {
            const vm = this
            vm.setShowCalendar(!vm.showCalendar)
        },
    },
    computed: {
        ...mapState(['account', 'showCalendar']),
        color(vm = this) {
            return vm.showCalendar ? 'secondary' : ''
        },
        canUseCalendar(vm = this) {
            if (vm.account.accountType === 'coach') return true
            return !!vm.account?.stripeAccount?.currentSubscription
        }
    },
}
</script>